import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { GlobalService } from 'src/app/services/global.service';
import { FormGroup, Validators, FormBuilder, FormArray, FormControl } from '@angular/forms';
import { HttpService } from 'src/app/services/http.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { DatepickerOptions } from 'ng2-datepicker';
import * as enLocale from 'date-fns/locale/en';
import { configs } from 'src/app/configs/app.config';
import { IDropdownSettings } from 'ng-multiselect-dropdown';

@Component({
  selector: 'app-edit-alert',
  templateUrl: './edit-alert.component.html',
  styleUrls: ['./edit-alert.component.scss']
})

export class EditAlertComponent {

  editAlert: FormGroup;
  public options: DatepickerOptions = {
    locale: enLocale,
    placeholder: 'Select Date',
    displayFormat: 'DD/MM/YY'
  };
  public conditionList = [];
  public successMessage: string = '';
  public errorMessage: string = "";
  public warningMessage = '';
  public selectedLocations: string = "";
  public selectedLocationArray: Array<Object> = [];
  public selectedAppsArray: Array<Object> = [];
  public selectedSpeedArray: Array<Object> = [];
  public selectedDeviceArray: Array<Object> = [];
  public selectedNetworArray: Array<Object> = [];
  public dropdownSettings: IDropdownSettings = {};
  public alertDetails: Object = {};
  public kpiList: Array<any> = [];
 
  constructor(private ngxService: NgxUiLoaderService, public globalService: GlobalService, public cd: ChangeDetectorRef, private formBuilder: FormBuilder, public httpService: HttpService) {
    this.fetchConditionList();
    this.editAlert = this.formBuilder.group({
      group_fk_select_name: ['', Validators.required],
      group_fk: [''],
      alertName: [''],
      value: [],
      location_select_name: [''],
      startDate: [''],
      endDate: [''],
      // stream: [''],
      alertId: [''],
      location: [''],
      operator_select_name: [''],
      operator: [''],
      downloadSpeed_select_name: [''],
      downloadSpeed: [''],
      kpi_select_name: [''],
      kpi: [''],
      timeWindow: [''],
      timeWindow_select_name: [''],
      appVersion: [''],
      appVersion_select_name: [''],
      appName: [''],
      appName_select_name: [''],
      condition: [''],
      condition_select_name: [''],
      deviceCategory: [''],
      deviceCategory_select_name: [''],
      locationArray:[],
      timeWindowArray:[],
      deviceCategoryArray:[],
      appVersionArray:[],
      operatorArray:[],
      downloadSpeedArray:[],
      kpiType:[''],
      kpiType_select_name:['']
    });
  }

  ngOnInit() {

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: false
    };
  }

 
  public fetchConditionList(): void {
    this.conditionList = [];
    this.httpService.createGetRequest(configs['api']['fetchConditionList'] + this.globalService.order_id)
      .subscribe((res) => {
        this.conditionList = this.globalService.toObject('', res);
      });
  }
  ///////// This is new ////////
  projectSettings(data) {
    return this.editAlert.get(data) as FormArray;
  }
  ///////////End ////////////////

  fillData(type:string,inputArr:Array<any>){
    if (this.alertDetails[type] && this.alertDetails[type].length > 0) {
      let arr = [];
      for (let index = 0; index < inputArr.length; index++) {
        const element = inputArr[index];
        if (this.alertDetails[type].indexOf(element['item_text']) > -1) {
          let obj = { 'item_id': element['item_id'], "item_text": element['item_text'] };
          arr.push(obj);
        }
      }
      let obj={};
      obj[type+'Array']=arr;
      this.editAlert.patchValue(obj);
    }
  }
  public storeKpiValue:any = '';

  ngDoCheck() {
    if (this.globalService.alertDetails && this.alertDetails != this.globalService.alertDetails) {
      this.alertDetails = this.globalService.alertDetails;
     
     this.fillData('location',this.globalService.dropdownList);
     this.fillData('operator',this.globalService.multiSelectNetwork);
     this.fillData('downloadSpeed',this.globalService.multiSelectSpeed);
     this.fillData('appVersion',this.globalService.multiSelectAppVersion);
     this.fillData('deviceCategory',this.globalService.multiSelectDeviceCategory);
     this.fillData('timeWindow',this.globalService.multiSelectTimeWindow);

     this.storeKpiValue = this.alertDetails['scoreName'];
      this.editAlert.patchValue({
         alertName: this.alertDetails && this.alertDetails['alertName'] ? this.alertDetails['alertName'] : "",
        condition: this.alertDetails && this.alertDetails['scoreCondition'] ? this.alertDetails['scoreCondition'] : "",
        value: this.alertDetails && this.alertDetails['value'] ? this.alertDetails['value'] : "",
        // location: this.alertDetails && this.alertDetails['location'] ? this.alertDetails['location'] : "",
        startDate: this.alertDetails && this.alertDetails['startDate'] ? this.alertDetails['startDate'] : "",
        endDate: this.alertDetails && this.alertDetails['endDate'] ? this.alertDetails['endDate'] : "",
        // operator: this.alertDetails && this.alertDetails['operator'] ? this.alertDetails['operator'] : "",
        kpi: this.alertDetails && this.alertDetails['scoreName'] ? this.alertDetails['scoreName'] : "",
        // downloadSpeed: this.alertDetails && this.alertDetails['downloadSpeed'] ? this.alertDetails['downloadSpeed'] : "",
        // appVersion: this.alertDetails && this.alertDetails['appVersion'] ? this.alertDetails['appVersion'] : "",
        deviceCategory: this.alertDetails && this.alertDetails['deviceCategory'] ? this.alertDetails['deviceCategory'] : "",
        // timeWindow: this.alertDetails && this.alertDetails['timeWindow'] ? this.alertDetails['timeWindow'] : "",
        appName: this.alertDetails && this.alertDetails['appname'] ? this.alertDetails['appname'] : "",
        // stream: this.alertDetails && this.alertDetails['liveStreaming'] ? this.alertDetails['liveStreaming'] : "",
        alertId: this.alertDetails && this.alertDetails['alertId'] ? this.alertDetails['alertId'] : undefined,
        kpiType:this.alertDetails && this.alertDetails['raw'] ? (this.alertDetails['raw']?'Metrics':'Index') : 'Index',
        kpiType_select_name:this.alertDetails && this.alertDetails['raw'] ? (this.alertDetails['raw']?'Metrics':'Index') :'Index',
      });
    }
  }

  public updateAlert(): void {
    if (this.editAlert['controls']['value']['value'] != null && this.editAlert['controls']['value']['value'] != undefined) {
      if (isNaN(this.editAlert['controls']['value']['value'])) {
        this.globalService.scrollToTop();
        this.warningMessage = 'Value should be a number';
        return;
      }
      if ((+ this.editAlert['controls']['value']['value'] < 1) || (+ this.editAlert['controls']['value']['value'] > 4)) {
        this.globalService.scrollToTop();
        this.warningMessage = 'Value should in between 1 and 4';
        return;
      }
    }
    this.httpService.createPutRequest(configs['api']['updateAlert'], {
      alertName: this.editAlert['controls']['alertName']['value'] ? this.editAlert['controls']['alertName']['value'] : undefined,
      condition: this.editAlert['controls']['condition']['value'] ? this.editAlert['controls']['condition']['value'] : undefined,
      value: this.editAlert['controls']['value']['value'],
      location: this.editAlert['controls']['locationArray']['value'] ? this.globalService.getDataAsString(this.editAlert['controls']['locationArray']['value']) : undefined,
      startDate: this.globalService.convertDate(this.editAlert['controls']['startDate']['value']) ? this.globalService.convertDate(this.editAlert['controls']['startDate']['value']) : "",
      endDate: this.globalService.convertDate(this.editAlert['controls']['endDate']['value']) ? this.globalService.convertDate(this.editAlert['controls']['endDate']['value']) : "",
      operator: this.editAlert['controls']['operatorArray']['value'] ? this.globalService.getDataAsString(this.editAlert['controls']['operatorArray']['value']) : undefined,
      scoreName: this.editAlert['controls']['kpi']['value'] ? this.editAlert['controls']['kpi']['value'] : undefined,
      downloadSpeed: this.editAlert['controls']['downloadSpeedArray']['value'] ? this.globalService.getDataAsString(this.editAlert['controls']['downloadSpeedArray']['value']) : undefined,
      appVersion: this.editAlert['controls']['appVersionArray']['value'] ? this.globalService.getDataAsString(this.editAlert['controls']['appVersionArray']['value']): undefined,
      deviceCategory: this.editAlert['controls']['deviceCategoryArray']['value'] ? this.globalService.getDataAsString(this.editAlert['controls']['deviceCategoryArray']['value']) : undefined,
      timeWindow: this.editAlert['controls']['timeWindowArray']['value'] ? this.globalService.getDataAsString(this.editAlert['controls']['timeWindowArray']['value']) : undefined,
      appName: this.editAlert['controls']['appName']['value'] ? this.editAlert['controls']['appName']['value'] : undefined,
      // liveStreaming: this.editAlert['controls']['stream']['value'] ? this.editAlert['controls']['stream']['value'] : undefined,
      alertId: this.editAlert['controls']['alertId']['value'] ? this.editAlert['controls']['alertId']['value'] : undefined,
      raw:this.editAlert['controls']['kpiType']?((this.editAlert['controls']['kpiType']['value']=='Index'|| this.editAlert['controls']['kpiType']['value']==false)?false:true):false,
      
    }, this.globalService.order_id).subscribe((res) => {
      this.ngxService.stop();
      this.successMessage = "Alert Updated Successfully";
      this.globalService.scrollToTop();
      setTimeout(() => {
        this.forPopupOpen('viewAlert');
      }, 3000);
    },
      (error) => {
        this.ngxService.stop();
        this.globalService.scrollToTop();
        this.errorMessage = error && error['statusMessage'] ? error['statusMessage'] : error && error['error'] && error.error['statusMessage'] ? error.error['statusMessage'] : '';
        this.warningMessage = (error.error['statusCode'] && error.error['statusCode'] === 406) ? error.error['statusMessage'] : '';
        setTimeout(() => {
          this.errorMessage = "";
          this.warningMessage = "";
        }, 3000);

      });
  }





  public changeSelection(selectedValue): void {
    setTimeout(() => {
      let option = selectedValue['fieldName'];
      this.editAlert.controls[option].setValue(selectedValue['id']);
      if(selectedValue['fieldName']=='kpiType'){
        if(this.editAlert['raw']==selectedValue['id']){
        this.fetchKpiList(this.editAlert['controls']['kpiType']['value'],true);
        }else{
        this.fetchKpiList(this.editAlert['controls']['kpiType']['value'],false);
        }
      }
    }, 0);
  }
  public fetchKpiList(val,bool): void {
    this.kpiList = [];
    this.httpService.createGetRequest(configs['api']['fetchKpiList'] + this.globalService.order_id+'?raw='+val).subscribe((response: any) => {
      if (response) 
        this.kpiList = this.globalService.toObject('', response);
        if(bool){
        this.editAlert['kpi'] = this.storeKpiValue;
        this.editAlert.get('kpi').setValue(this.editAlert['kpi'])
        }else{
        this.editAlert['kpi']=this.kpiList[0]['id'];
        this.editAlert.get('kpi').setValue(this.editAlert['kpi'])
        }
    });

  }
  forPopupClose() {
    this.globalService.showPopUp = "";
    document.body ? document.body.classList.remove('no-scroll') : '';
  }

  forPopupOpen(key) {
    this.globalService.showPopUp = key;
    document.body ? document.body.classList.add('no-scroll') : '';
  }
}
